import styled from "styled-components";

export const Container = styled.div`
  height: fit-content;
  padding: 1rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 90%;
  width: 90%;
  box-shadow: 0 0 10px rgb(0 0 0 / 0.2);
  border-radius: 24px;
  @media only screen and (min-width: 867px) {
    height: ${(props) => (props.isDnD ? "calc(100% - 2rem)" : "40vh")};
    max-width: ${(props) => (props.isDnD ? "100%" : "60%")};
    width: ${(props) => (props.isDnD ? "calc(100% - 2rem)" : "60%")};
  }
`;
